export function contentSlot(extras = {}) {
    return Object.freeze({
        kind: 'content',
        ...extras,
    });
}
export function textSlot(extras = {}) {
    return Object.freeze({
        kind: 'text',
        ...extras,
    });
}
export function dataSlot(item, extras = {}) {
    return Object.freeze({
        kind: 'data',
        item,
        ...extras,
    });
}
export function slotsRecord(slots) {
    return Object.freeze(Object.fromEntries(Object.entries(slots).map(([slotName, slotDefinition]) => [
        slotName,
        Object.freeze({
            ...slotDefinition,
            ...(slotDefinition.item && { item: slotDefinition.item }),
        }),
    ])));
}
export function normalizeSlotDefinitions(slots) {
    if (!slots) {
        return undefined;
    }
    if (Array.isArray(slots)) {
        return slotsRecord(Object.fromEntries(slots.map((slotName) => [slotName, contentSlot({ multiple: true })])));
    }
    return slotsRecord(slots);
}
//# sourceMappingURL=schema-slot-builders.js.map